import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DailyHoursWorkedChart from "../components/DailyHoursWorkedChart";
import DailyHoursSummaryTable from "../components/DailyHoursSummaryTable";
import DateSelector from "../components/DateSelector";
import DailyViewLayout from "../components/DailyViewLayout";
import { formatLocalDate } from "../utils/localDateTime";

const DailyHoursWorkedOverview = () => {
  const { date } = useParams();
  const navigate = useNavigate();
  const selectedDate = date || formatLocalDate(new Date());
  const [chartLoading, setChartLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(true);

  // Reset loading states when date changes
  useEffect(() => {
    setChartLoading(true);
    setTableLoading(true);
  }, [selectedDate]);

  useEffect(() => {
    if (!date || date !== selectedDate) {
      navigate(`/chart/daily/hours/${selectedDate}`, { replace: true });
    }
  }, [date, selectedDate, navigate]);

  const handleDateChange = useCallback((newDate) => {
    navigate(`/chart/daily/hours/${newDate}`);
  }, [navigate]);

  // Check if any data is still loading
  const isAnyLoading = chartLoading || tableLoading;

  return (
    <DailyViewLayout date={selectedDate}>
      <DateSelector
        date={selectedDate}
        setDate={handleDateChange}
        disabled={isAnyLoading}
      />
      <DailyHoursWorkedChart date={selectedDate} onLoadingChange={setChartLoading} />
      <DailyHoursSummaryTable date={selectedDate} onLoadingChange={setTableLoading} />
    </DailyViewLayout>
  );
};

export default DailyHoursWorkedOverview;
